import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { isDevMode, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { routes } from './app/app.routes';
import { keycloakHttpInterceptor } from './app/interceptor/keycloak-http.interceptor';

registerLocaleData(localePt, 'pt-BR');

// O poster do vídeo da landing é o LCP: começa a baixar antes do bootstrap, para já estar
// pronto quando a landing renderizar. Fica aqui e não no index.html porque lá ele disputava
// banda com o JS inicial (~90 ms a mais no Slow 4G) e baixava em toda rota — medido em
// 2026-09-22, quando o bootstrap ainda esperava o Keycloak; com o render mais cedo, a folga
// ficou em ~90 ms no desktop, então vale medir de novo se o render adiantar mais. O caminho é
// o mesmo do atributo poster em landing-page.component.html: mudou lá, muda aqui.
if (location.pathname === '/' || location.pathname === '/inicio') {
  const poster = document.createElement('link');
  poster.rel = 'preload';
  poster.as = 'image';
  poster.href = '/assets/imgs/landing/lp-background-poster.webp';
  document.head.appendChild(poster);

  // O chunk da landing: sem isto o router so o pede depois do bootstrap, e so descobre os
  // imports do Material dele quando ele chega — duas voltas em série (~1 s no Slow 4G, medido
  // em 2026-09-22). Não é import eager: é o mesmo import() da rota em app.routes.ts, o mesmo
  // chunk lazy, pedido antes; o router encontra o módulo já carregando. Falha aqui fica
  // quieta: quem mostra o erro é o import do próprio router.
  import('./app/components/landing-page/landing-page.component').catch(() => undefined);
}

bootstrapApplication(AppComponent, {
  providers: [
    ...appConfig.providers,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideHttpClient(withFetch(), withInterceptors([keycloakHttpInterceptor])),
    provideRouter(routes, withViewTransitions()),
    provideServiceWorker(
      'ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
}).catch(err => {
  console.error('Application bootstrapping failed:', err);
});
